import {  useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import Loading from "../../customer/Loading";
import 'antd/dist/antd.min.css'
import { Tooltip } from "antd";
import { format } from "date-fns"

const ViewOrderNoTvv = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
   
    const columns = [
        {
            title: 'Tên khách hàng',
            dataIndex: 'customers',
            // align: "center",
            width: 100,
            fixed : 'left',
            render: (data) => {
                return (
                    <p className="text1">{data.full_name}</p>
                )
            },
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customers',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="">{data.mobile}</p>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            dataIndex: 'order_code',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Ngày lên đơn hàng',
            dataIndex: 'order_at',
            // align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text4">{format(new Date(data), "yyyy-MM-dd")}</p>
                )
            },
        },

        {
            title: 'Số tiền nợ',
            dataIndex: 'money_owed',
            align: "center",
            width: 100,
            render: (data) => {
                return (
                    <p className="text2">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Dịch vụ mua',
            dataIndex: 'orderItem',
            align: "center",
            width: 120,
            render: (data) => {
                let string = ''
                for (let item of data) {
                    string += `<p className="text1">${item.product_name}</p>`
                }
                return (<div dangerouslySetInnerHTML={{__html: string}} />)
            },
        },
        {
            title: 'Cơ sở',
            align: "center",
            width: 100,
            render: (data) => {
                return (<p className="text4">{data?.stores?.name_store ?? ""}</p>)
            },
        },
    ];
    const handelExportUser = () => {
        
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            Bảng số liệu chi tiết
                        </Col>
                        <Col xs={6}>
                            {/* <Button size="middle" type="primary" onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey="id"
                />
            </div>
            <Loading
            show={showLoading}
             ></Loading>
        </>
    )
}
export default ViewOrderNoTvv